module.exports = __webpack_public_path__ + "img/116.4798743b.png";